<template>
  <UikitIcon
    :class="{
      'osk-tooltip': true,
      'osk-tooltip_disabled': disabled,
    }"
    name="Info"
    color="grey"
    @click.stop.prevent="handleTooltip"
  />

  <UikitDialog
    v-model="tooltipDialog"
    full-height
    position="right"
    content-class="osk-tooltip-dialog"
    hide-close
  >
    <div class="osk-tooltip-dialog__wrapper">
      <div
        v-if="!isDesktop"
        class="osk-tooltip-dialog__header"
      >
        <UikitIcon
          name="ArrowBack"
          size="l"
          @click="tooltipDialog = false"
        />
      </div>

      <div class="osk-tooltip-dialog__content">
        <div
          v-if="title"
          class="osk-tooltip-dialog__title"
        >
          {{ title }}
        </div>

        <slot />
      </div>

      <div class="osk-tooltip-dialog__footer">
        <UikitButton
          full-width
          @click="tooltipDialog = false"
        >
          Понятно
        </UikitButton>
      </div>
    </div>
  </UikitDialog>
</template>

<script lang="ts" setup>
const props = defineProps<{
  disabled?: boolean
  title?: string
}>();

const emits = defineEmits<{
  (e: 'open'): void,
}>();

const { isDesktop } = useUiBreakpoints();

const tooltipDialog = ref(false);

function handleTooltip() {
  if (props.disabled) return;

  tooltipDialog.value = true;

  emits('open');
}
</script>

<style lang="scss">
@import "~/assets/scss/settings/index";

.osk-tooltip {
  color: $grey;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: 100%;
  cursor: pointer;

  &_disabled {
    opacity: .3;
    pointer-events: none;
  }
}

.osk-tooltip-dialog {
  padding-top: 0 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;

  @include media-query(lg-and-up) {
    width: 504px !important;
    padding: 100px 0 0 0!important;
  }

  .osk-dialog__close {
    @include media-query(lg-and-up) {
      right: 50px;
    }
  }

  &__header {
    display: flex;
    align-items: center;
    position: relative;
    padding: 10px $indent-medium;

    .osk-icon {
      margin-left: -6px;
    }
  }

  &__wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  &__content {
    padding: 22px $indent-medium 16px;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    height: 100%;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }

    @include media-query(lg-and-up) {
      padding: 0 52px 24px;
    }
  }

  &__title {
    font-weight: 700;
    font-size: 22px;
    line-height: 27px;
    margin-bottom: 34px;

    @include media-query(lg-and-up) {
      @include font-style($font-size-heading, $line-height-heading, $font-weight-bold);
      margin-bottom: 32px;
    }
  }

  &__footer {
    padding: $indent-mmedium $indent-medium 0;

    @include media-query(lg-and-up) {
      padding: $indent-large 52px 52px;
    }
  }
}
</style>
